<template>
  <div>
    <!-- <PageHead title="创建部门主送组"></PageHead> -->
    <PageHead title="部门主送管理"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="search-flex-item mr20">
          <span>主送至部门组：</span>
          <a-input
            class="w300"
            placeholder="请输入主送至部门组"
            v-model="queryForm.groupName"
          />
        </div>
        <div class="search-flex-item">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel">
            取消
          </a-button>
        </div>
      </div>
      <div class="mt20 mb20">
        <a-button type="primary" @click="add()" icon="plus"> 新建</a-button>
      </div>
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="groupList"
        rowKey="id"
        :loading="loading"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="add(record)">
            编辑
          </a-button>
          <a-divider type="vertical" />
          <a-button
            type="link"
            class="btn-link"
            @click="showDeleteConfirm(record.id)"
          >
            删除
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination v-model="page" :total="total" @change="pageChange" />
      </div>
    </div>
    <appfloor></appfloor>
    <a-modal v-model="visible" title="主送配置" @ok="handleOk" :width="800">
      <div class="role-formCont">
        <span class="w100 rightAlgin">主送至部门组:</span>
        <a-input
          class="w300 ml20"
          placeholder="请输入主送至部门组"
          v-model="addForm.groupName"
        />
      </div>
      <blank height="20"> </blank>
      <div class="role-formCont">
        <span class="w100 rightAlgin">主送说明:</span>
        <a-textarea
          class="w300 ml20"
          placeholder="请输入主送说明"
          v-model="addForm.groupExplain"
          :rows="2"
        />
      </div>

      <blank height="20"> </blank>
      <div class="role-scrollY">
        <div class="role-formCont">
          <!-- <div class="role-formlabel">
            <a-checkbox v-model="checkAll" @change="onCheckAllChange">
              全选
            </a-checkbox>
          </div>
          <div class="role-formvalue">
            <a-checkbox-group v-model="addForm.orgIds" @change="orgIdsonChange">
              <a-checkbox
                v-for="(item, index) in orgIds"
                :key="index"
                :value="item.organizationId"
              >
                {{ item.organizationName }}
              </a-checkbox>
            </a-checkbox-group>
          </div> -->
          <a-tree
            v-model="addForm.orgIds"
            checkable
            :tree-data="treeData"
            :replaceFields="{
              children: 'treeList',
              title: 'organizationName',
              key: 'id'
            }"
            :default-expanded-keys="expandedKeys"
          />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'index' }
  },
  {
    title: '主送至部门组',
    dataIndex: 'groupName',
    key: 'groupName',
    ellipsis: true,
    align: 'left'
  },
  {
    title: '主送说明',
    dataIndex: 'groupExplain',
    key: 'groupExplain',
    ellipsis: true,
    align: 'left'
  },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 160
  }
]
import {
  getGroupList,
  addGroup,
  updateGroup,
  delGroup,
  getOrgIds,
  getGroupDetial,
  getTreeList
} from './api/api'
export default {
  data() {
    return {
      visible: false,
      queryForm: {},
      addForm: {
        groupName: '',
        groupExplain: '',
        orgIds: []
      },
      page: 1,
      size: 10,
      total: 0, //总条数
      groupList: [], //权限列表
      orgIds: [], // 菜单列表
      treeData: [], // 组织机构菜单列表
      expandedKeys: [10010], //当前默认选中的机构 ，为了保证默认展开
      checkAll: false,
      columns,
      loading: false
    }
  },
  computed: {
    allorgIds: function () {
      // `this` 指向 vm 实例
      // 全选
      let Header = []
      for (const value of this.orgIds) {
        Header.push(value.organizationId)
      }
      return Header
    }
  },
  created() {
    this.load()
    getTreeList().then((res) => {
      this.treeData = res.data.data
    })
    getOrgIds().then((res) => {
      //获取菜单列表
      if (res.data.code == 0) {
        this.orgIds = res.data.data
      }
    })
  },
  methods: {
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      getGroupList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.groupList = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          let formData=new FormData()
          formData.append('id',id)
          delGroup(formData).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.load()
            }
          })
        }
      })
    },
    handleOk() {
      // 确认修改/添加
      if (this.addForm.id) {
        updateGroup(this.addForm).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('操作成功')
            this.load()
            this.visible = false
          }
        })
      } else {
        addGroup(this.addForm).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('添加成功')
            this.load()
            this.visible = false
          }
        })
      }
    },

    add(addForm) {
      if (addForm) {
        // 修改
        this.addForm = addForm
        this.orgIdsonChange()
      } else {
        this.addForm = { groupName: '', groupExplain: '', orgIds: [] }
      }
      this.visible = true
    },
    onCheckAllChange(e) {
      if (e.target.checked) {
        // 全选
        this.addForm.orgIds = this.allorgIds
      } else {
        this.addForm.orgIds = []
      }
    },

    orgIdsonChange() {
      //判断是否全选
      if (this.addForm.orgIds.length == this.allorgIds.length) {
        //全部选择
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.load()
    },
    cancel() {
      //取消
      this.queryForm = {}
    },
    subMit() {
      //搜索
      this.page = 1
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.role-scrollY {
  overflow-y: scroll;
  max-height: calc(100vh - 500px);
}
// .role-scrollY::-webkit-scrollbar {
//   display: none;
// }
.role-formCont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
  .role-formlabel {
    width: 120px;
    text-align: right;
    margin-right: 20px;
  }
  .role-formvalue {
    width: calc(100% - 120px);
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/grouping.vue